import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Login from './Pages/Login'
import Dashboard from './Pages/Dashboard'
import Order from './Pages/MenuOrder/Order'
import COA from './Pages/MenuOrder/COA'
import Analytic from './Pages/Analytic'
import DetailCarousel from './Pages/Dashboard/Carousel/DetailCarousel'
import FormOrder from './Pages/MenuOrder/Order/Form'
import Layouts from './Components/Layouts'
import FormSample from './Pages/MenuOrder/Order/Form/FormSample'
import FormCOA from './Pages/MenuOrder/COA/FormCOA'
import Profile from './Pages/Profil'
import FormInvoice from './Pages/Invoice/Form'
import AccountAdmin from './Pages/AccountAdmin'
import News from './Pages/News'
import FormAccountAdmin from './Pages/AccountAdmin/form'
import FormNews from './Pages/News/form'
import InvoicePrint from './Pages/InvoicePrint'
import MenuLiveChat from './Pages/MenuLiveChat'
import Sample from './Pages/MenuOrder/Sample'
import OrdersDetail from './Pages/MenuOrder/Order/OrdersDetail'
import SamplesDetail from './Pages/MenuOrder/Sample/DetailSample'
import Sales from './Pages/Sales'
import FormSales from './Pages/Sales/form'
import Parameter from './Pages/Parameter'
import FormParameter from './Pages/Parameter/form'
import CustomerAccount from './Pages/CustomerAccount'
import FormCustomerAccount from './Pages/CustomerAccount/form'
import COADetail from './Pages/MenuOrder/COA/COADetail'
import Invoice from './Pages/Invoice'
import DetailInvoice from './Pages/Invoice/DetailInvoice'
import Cookies from 'js-cookie';
import { AuthData } from './Components/Global'
import DetailEmailInvoice from './Pages/Invoice/DetailInvoice/DetailEmailInvoice'

const App = () => {

  const AuthRoute = ({ element }) => {
    const [isAuth, setIsAuth] = useState(null);

    const cekAuth = async () => {
      try {
        const token = Cookies.get('auth_token');
        const userAuth = AuthData();
        if (!token && !userAuth) {
          setIsAuth(false);
          return;
        } else {
          setIsAuth(true);
        }
      } catch (error) {
        setIsAuth(false);
      }
    }

    useEffect(() => {
      cekAuth();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isAuth === null) return null;

    return isAuth ? element : <Navigate to="/" />

  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/invoice/print/:accountid/:code" element={<InvoicePrint />} />

        <Route path='/coa/:accountid/:code' element={<COADetail />} />
        <Route path='/invoice/:accountid/:code' element={<DetailEmailInvoice />} />

        <Route path="/dashboard/*" element={
          <AuthRoute element={
            <Layouts>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/detailbanner/:id" element={<DetailCarousel />} />
                <Route path='/analytic' element={<Analytic />} />
                <Route path='/roomchat' element={<MenuLiveChat />} />
                <Route path='/profile' element={<Profile />} />

                <Route path='/configuration/*' element={
                  <Routes>
                    <Route path='/customeraccount/*' element={
                      <Routes>
                        <Route path='/' element={<CustomerAccount />} />
                        <Route path='/form' element={<FormCustomerAccount />} />
                      </Routes>
                    } />
                    <Route path='/adminaccount/*' element={
                      <Routes>
                        <Route path='/' element={<AccountAdmin />} />
                        <Route path='/form' element={<FormAccountAdmin />} />
                      </Routes>
                    } />
                  </Routes>
                } />

                <Route path='/master/*' element={
                  <Routes>
                    <Route path='/sales/*' element={
                      <Routes>
                        <Route path='/' element={<Sales />} />
                        <Route path='/form' element={<FormSales />} />
                      </Routes>
                    } />
                    <Route path='/parameter/*' element={
                      <Routes>
                        <Route path='/' element={<Parameter />} />
                        <Route path='form' element={<FormParameter />} />
                      </Routes>
                    } />
                    <Route path='/news/*' element={
                      <Routes>
                        <Route path='/' element={<News />} />
                        <Route path='form' element={<FormNews />} />
                      </Routes>
                    } />
                  </Routes>
                } />

                <Route path="/menuorder/*" element={
                  <Routes>

                    {/* ORDER */}
                    <Route path='/order/*' element={
                      <Routes>
                        <Route path='/' element={<Order />} />
                        <Route path='/:accountid/:code' element={<OrdersDetail />} />
                        <Route path='/form' element={<FormOrder />} />
                        <Route path='/sample/form' element={<FormSample />} />
                      </Routes>
                    } />

                    {/* SAMPLE */}
                    <Route path='/sample/*' element={
                      <Routes>
                        <Route path='/' element={<Sample />} />
                        <Route path='/:accountid/:code' element={<SamplesDetail />} />
                      </Routes>
                    } />

                    {/* COA */}
                    <Route path='/coa/*' element={
                      <Routes>
                        <Route path='/' element={<COA />} />
                        <Route path=':accountid/:code' element={<COADetail />} />
                        <Route path='form' element={<FormCOA />} />
                        <Route path='form/:accountid/:code' element={<FormCOA />} />
                      </Routes>
                    } />
                  </Routes>
                } />

                <Route path="/invoice/*" element={
                  <Routes>
                    <Route path='/' element={<Invoice />} />
                    <Route path='/form' element={<FormInvoice />} />
                    <Route path='/form/:accountid/:code' element={<FormInvoice />} />
                    <Route path='/:accountid/:code' element={<DetailInvoice />} />
                  </Routes>
                } />

              </Routes>
            </Layouts>
          } />
        } />
        {/* <Route path="/customer/*" element={
          <Layouts>
            <Routes>
              <Route path='dashboard' element={<DashboardCustomer />} />
              <Route path='analytic' element={<Analytic />} />
            </Routes>
          </Layouts>
        } /> */}
      </Routes >
    </>
  )
}

export default App